//changed due to package upgrade
import AppCard from '@projectK/components/AppCard';
import React, { useState } from 'react';
import {
  alpha,
  Autocomplete,
  Button,
  Grid,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import PropTypes from 'prop-types';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import dayjs from 'dayjs';

const PromoCodeFilters = ({
  setProductFilter,
  productFilter,
  setStartDateFilter,
  startDateFilter,
  setEndDateFilter,
  endDateFilter,
  setStatusFilter,
  statusFilter,
  setTypeFilter,
  typeFilter,
  setPage,
  productOptions,
  tournamentFilter,
  setTournamentFilter,
  tournamentOptions,
  component,
  hasTournamentAddon,
}) => {
  const companyTheme = CompanyTheme();
  const { verbiageSettings } = useApplicationSettings();
  const [isExpandFilter, setIsExpandFilter] = useState(true);
  const [searchTermProduct, setSearchTermProduct] = useState('');
  const handleDateFilers = ({ filterType, value }) => {
    if (filterType === 'startDate') {
      if (value === '') {
        setStartDateFilter('');
      } else {
        setStartDateFilter(value);
      }
      setPage(0);
    }
    if (filterType === 'endDate') {
      if (value === '') {
        setEndDateFilter('');
      } else {
        setEndDateFilter(value);
      }
      setPage(0);
    }
  };
  const handleFilterChange = (filterType, value) => {
    if (filterType === 'status') {
      setStatusFilter(value);
      setPage(0);
    }
    if (filterType === 'productId') {
      setProductFilter(value ? value.id : '');
      setPage(0);
    }
    if (filterType === 'promocodeType') {
      setTypeFilter(value === 'All' ? '' : value);
      setPage(0);
    }
    handleDateFilers({ filterType, value });
    if (filterType === 'tournamentId') {
      setTournamentFilter(value ? value.id : '');
      setPage(0);
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const toggleFilter = () => {
    setIsExpandFilter(!isExpandFilter);
  };

  const clearFilter = () => {
    setProductFilter('');
    setStartDateFilter('');
    setEndDateFilter('');
    setStatusFilter('');
    setStatusFilter('');
    setTypeFilter('');
    setPage(0);
    setTournamentFilter('');
  };

  let startDate = new Date(`${startDateFilter?.substring(0, 10)}T12:01:00`);
  let endDate = new Date(`${endDateFilter?.substring(0, 10)}T12:01:00`);

  const promocodeStatus = [
    { statusName: 'Active', statusValue: 1 },
    { statusName: 'In-Active', statusValue: 0 },
  ];
  const promocodeTypes = [
    { type: 'Fixed', typeValue: 'fixed' },
    { type: 'Percentage', typeValue: 'percentage' },
  ];
  return (
    <AppCard
      title='Filter Promo Codes'
      style={{ position: 'relative' }}
      onClick={toggleFilter}
      action={
        <IconButton
          onClick={toggleFilter}
          size='small'
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
          }}
        >
          {isExpandFilter ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}
        </IconButton>
      }
    >
      {isExpandFilter && (
        <AppGridContainer spacing={5} onClick={stopPropagation}>
          {component !== 'tournament' && (
            <>
            <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
            <Autocomplete
                  options={(productOptions || []).sort((a, b) =>
                    a.product_name.localeCompare(b.product_name, undefined, {
                      numeric: true,
                      sensitivity: 'base',
                    }),
                  )}
                  getOptionLabel={(option) =>
                    option.badge
                      ? `${option.product_name} - ${option.badge}`
                      : option.product_name
                  }
                  value={
                    productOptions.find((p) => p.id === productFilter) || null
                  }
                  onChange={(_, value) =>
                    handleFilterChange('productId', value || {})
                  }
                  inputValue={searchTermProduct}
                  onInputChange={(_, value) => setSearchTermProduct(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={verbiageSettings.product_type || 'Products'}
                      variant='outlined'
                    />
                  )}
                />
              </Grid>
              {hasTournamentAddon && (            <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>

                <Autocomplete
                  options={(tournamentOptions || []).sort((a, b) =>
                    a.tournament_name.localeCompare(
                      b.tournament_name,
                      undefined,
                      {
                        numeric: true,
                        sensitivity: 'base',
                      },
                    ),
                  )}
                  getOptionLabel={(option) => option.tournament_name}
                  value={
                    tournamentOptions?.find((p) => p.id === tournamentFilter) ||
                    null
                  }
                  onChange={(_, value) =>
                    handleFilterChange('tournamentId', value || {})
                  }
                  // inputValue={searchTermProduct}
                  // onInputChange={(_, value) => setSearchTermProduct(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={'Tournaments'}
                      variant='outlined'
                    />
                  )}
                />
              </Grid>)}{' '}
            </>
          )}
          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={1}>
                <DatePicker
                  label='Start Date'
                  sx={{
                    width: '100%',
                    backgroundColor: 'background.paper',
                    color: 'text.primary',
                  }}
                  value={startDateFilter ? startDate : null}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(value) => {
                    const formattedDate = dayjs(value)
                      .startOf('day')
                      .format('YYYY-MM-DD');
                    handleFilterChange(
                      'startDate',
                      formattedDate === 'Invalid Date' ? '' : formattedDate,
                    );
                  }}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>
          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={1}>
                <DatePicker
                  label='End Date'
                  sx={{
                    width: '100%',
                    backgroundColor: 'background.paper',
                    color: 'text.primary',
                  }}
                  value={endDateFilter ? endDate : null}
                  renderInput={(params) => <TextField {...params} />}
                  onChange={(value) => {
                    const formattedDate = dayjs(value)
                      .startOf('day')
                      .format('YYYY-MM-DD');
                    handleFilterChange(
                      'endDate',
                      formattedDate === 'Invalid Date' ? '' : formattedDate,
                    );
                  }}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>
          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <Autocomplete
              options={promocodeStatus || []}
              getOptionLabel={(option) => option.statusName}
              value={
                promocodeStatus.find((a) => a.statusValue === statusFilter) ||
                null
              }
              onChange={(_, value) => {
                handleFilterChange('status', value?.statusValue);
              }}
              renderInput={(params) => (
                <TextField {...params} label='Status' variant='outlined' />
              )}
            />
          </Grid>

          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <Autocomplete
              options={promocodeTypes || []}
              getOptionLabel={(option) => option.type}
              value={
                promocodeTypes.find((a) => a.typeValue === typeFilter) || null
              }
              onChange={(_, value) => {
                handleFilterChange('promocodeType', value?.typeValue || '');
              }}
              renderInput={(params) => (
                <TextField {...params} label='Type' variant='outlined' />
              )}
            />
          </Grid>
          <Grid  size={{ xs: 12, md: 4,sm: 6,  }}>
          <Button
              variant='outlined'
              sx={{
                borderColor: companyTheme
                  ? companyTheme.primary.main
                  : '#2196f3',
                '&:hover': {
                  borderColor: companyTheme
                    ? alpha(companyTheme.primary.main, 0.8)
                    : alpha('#2196f3', 0.8),
                },
                color: companyTheme ? companyTheme.primary.main : '#2196f3',
              }}
              onClick={clearFilter}
            >
              Clear Filter
            </Button>
          </Grid>
        </AppGridContainer>
      )}
    </AppCard>
  );
};

PromoCodeFilters.propTypes = {
  productFilter: PropTypes.string.isRequired,
  setProductFilter: PropTypes.func.isRequired,
  isFilterOpen: PropTypes.bool.isRequired,
  setIsFilterOpen: PropTypes.func.isRequired,
  setStartDateFilter: PropTypes.func,
  startDateFilter: PropTypes.bool,
  setEndDateFilter: PropTypes.func,
  endDateFilter: PropTypes.bool,
  setStatusFilter: PropTypes.func,
  statusFilter: PropTypes.bool,
  setTypeFilter: PropTypes.func,
  typeFilter: PropTypes.bool,
  setPage: PropTypes.func,
  productOptions: PropTypes.array,
  tournamentFilter: PropTypes.bool,
  setTournamentFilter: PropTypes.func,
  tournamentOptions: PropTypes.array,
  component: PropTypes.string,
  hasTournamentAddon: PropTypes.bool,
};

export default PromoCodeFilters;
